import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import TechnicalKnowledgeServices from "./TechnicalKnowledge.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getTechnicalKnowledge = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_TECHNICAL_KNOWLEDGE,
      payload: true,
    });
    const resp = await TechnicalKnowledgeServices.getTechnicalKnowledge(filters);
    dispatch({
      type: actions.GET_TECHNICAL_KNOWLEDGE,
      payload: {
        technicalKnowledges: resp.data.data,
        technicalKnowledgesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.TECHNICAL_KNOWLEDGE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TECHNICAL_KNOWLEDGE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TECHNICAL_KNOWLEDGE,
      payload: false,
    });
  }
};

export const getTechnicalKnowledgeById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_TECHNICAL_KNOWLEDGE,
      payload: true,
    });
    const resp = await TechnicalKnowledgeServices.getTechnicalKnowledgeById(id);
    dispatch({
      type: actions.GET_TECHNICAL_KNOWLEDGE,
      payload: {
        technicalKnowledge: resp.data
      },
    });
    dispatch({
      type: actions.TECHNICAL_KNOWLEDGE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TECHNICAL_KNOWLEDGE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TECHNICAL_KNOWLEDGE,
      payload: false,
    });
  }
};

export const saveTechnicalKnowledge = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_TECHNICAL_KNOWLEDGE,
      payload: true,
    });
    const resp = await TechnicalKnowledgeServices.saveTechnicalKnowledge(data);
    const { technicalKnowledges, technicalKnowledgesLength } = getState().technicalKnowledge;
    const _technicalKnowledges = [...technicalKnowledges, resp.data];
    dispatch({
      type: actions.GET_TECHNICAL_KNOWLEDGE,
      payload: {
        technicalKnowledges: _technicalKnowledges,
        technicalKnowledgesLength: technicalKnowledgesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: {},
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    let _message = {};
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            _message=ex.response.data
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: _message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_TECHNICAL_KNOWLEDGE,
      payload: false,
    });
  }
};

export const editTechnicalKnowledge = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_TECHNICAL_KNOWLEDGE,
      payload: true,
    });
    const resp = await TechnicalKnowledgeServices.editTechnicalKnowledge(id, data);
    const { technicalKnowledges, technicalKnowledgesLength } = getState().technicalKnowledge;
    technicalKnowledges[index] = resp.data;
    dispatch({
      type: actions.GET_TECHNICAL_KNOWLEDGE,
      payload: {
        technicalKnowledges: technicalKnowledges,
        technicalKnowledgesLength: technicalKnowledgesLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: {},
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    let _message = {};
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            _message=ex.response.data
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
    dispatch({
      type: actions.FORM_FAIL_JSON,
      payload: _message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TECHNICAL_KNOWLEDGE,
      payload: false,
    });
  }
};

export const deleteTechnicalKnowledge = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_TECHNICAL_KNOWLEDGE,
      payload: true,
    });
    await TechnicalKnowledgeServices.deleteTechnicalKnowledge(id);
    const { technicalKnowledges, technicalKnowledgesLength } = getState().technicalKnowledge;
    technicalKnowledges.splice(index, 1);
    dispatch({
      type: actions.GET_TECHNICAL_KNOWLEDGE,
      payload: {
        technicalKnowledges: technicalKnowledges,
        technicalKnowledgesLength: technicalKnowledgesLength - 1,
      },
    });
    dispatch({
      type: actions.TECHNICAL_KNOWLEDGE_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.TECHNICAL_KNOWLEDGE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_TECHNICAL_KNOWLEDGE,
      payload: false,
    });
  }
};
